import SwiperCore, { Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Device from "../../../../shared/components/global/Device";
import ReasonCard from "../../../../shared/components/speed-recruiting/ReasonCard";
import {
  FeaturesSectionContent,
  FeaturesSectionSwiperContent,
  ReasonsSwiperContainer,
  SwiperWrapper,
} from "../../../../shared/styles/swiper/swiper";
import HomeSVG from "/public/svg/speed-recruiting/home.svg";
import MoneySVG from "/public/svg/speed-recruiting/money.svg";
import RocketSVG from "/public/svg/speed-recruiting/rocket.svg";
import TimeSVG from "/public/svg/speed-recruiting/time.svg";
import TravelSVG from "/public/svg/speed-recruiting/travel.svg";

SwiperCore.use([Pagination]);

const reasons: any = [
  {
    title:
      "Du kannst sowohl als Quereinsteiger*in, aber auch mit Touristik-Erfahrungen mitmachen.",
    image: <TravelSVG />,
  },
  {
    title: "Das easyboarding ist für Bewerber*innen vollständig kostenlos.",
    image: <MoneySVG />,
  },
  {
    title: "Die Bewerbung hier auf der Website dauert nur 19 Minuten",
    image: <TimeSVG />,
  },
  {
    title: "Du investierst nur einen Abend in einen großartigen Karriere-Boost",
    image: <RocketSVG />,
  },
  {
    title:
      "Du kannst mit nur einer Bewerbung bis zu 12 Vorstellungsgespräche ergattern",
    image: <HomeSVG />,
  },
];

export const ReasonSwiper = ({
  buttonText,
  customReasons,
}: {
  buttonText?: string;
  customReasons?: any;
}) => {
  let useReasons = reasons;
  if (customReasons != null) {
    useReasons = customReasons;
  }

  return (
    <ReasonsSwiperContainer>
      <FeaturesSectionContent>
        <h2>Es gibt viele Gründe an unserem Speed-Recruiting teilzunehmen.</h2>
      </FeaturesSectionContent>
      <FeaturesSectionSwiperContent>
        <SwiperWrapper>
          <Device>
            {({ isMobile }) => (
              <Swiper
                cssMode={isMobile}
                grabCursor={true}
                slidesPerView={"auto"}
                pagination={{ clickable: true }}
                slideToClickedSlide
                className="reasons-swiper"
              >
                {useReasons.map((reason) => (
                  <SwiperSlide key={reason.title}>
                    <ReasonCard
                      title={reason.title}
                      image={reason.image}
                      buttonText={buttonText}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Device>
        </SwiperWrapper>
      </FeaturesSectionSwiperContent>
    </ReasonsSwiperContainer>
  );
};
